export default async function confirmPromise(message) {
  return new Promise((resolve, reject) => {
    const confirmed = window.confirm(message);
    return confirmed ? resolve(true) : resolve(false);
  });
}
